import { render, staticRenderFns } from "./view.vue?vue&type=template&id=0521c1ac&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=0521c1ac&prod&lang=scss"
import style1 from "./view.vue?vue&type=style&index=1&id=0521c1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521c1ac",
  null
  
)

export default component.exports